import React, { useState, useEffect } from "react";
import styles from "./Subproject.module.scss";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import {
  openMainModal,
  setPostulationProject,
  getProjectQuestions,
  setOpenMainId,
  getSubProjectBudgets,
} from "../../../store/actions/profileActions";
import DetailsInfo from "./DetailsInfo";
import { fireAnalytics } from "../../../utils/firebase";
import HeaderWithButton from "../../UI/HeaderWithButton/HeaderWithButton";
import DetailsEdit from "../../UI/DetailsEdit/DetailsEdit";
import { set } from "lodash";

const Subproject = ({
  onClick,
  opened,
  handlePostulation,
  allowOpen,
  isPostulating,
  updatePortfolio,
  formik,
  fromPage,
  handleClose,
  defaultDropdownOpen,
  getSubProjectBudgets,
  newImage,
  isVisualizer,
  isPortfolio,
  isProject,
  setOpenMainId,
  openMainId,
  openMainModal,
  item,
  isPostulation,
  setPostulationProject,
  getProjectQuestions,
  displayInfo,
  type,
  setOpenItem,
  openItem,
  isAllowed,
  subProjectBudgets,
  count,
  dat,
  mainProject,
  ...props
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(defaultDropdownOpen);
  const [isEditing, setIsEditing] = useState(false);
  const [initialValues, setInitialValues] = useState({});
 
  
  let { name, description, startDate = "", endDate = "", zone, id } = item;


  useEffect(() => {
    if (
      !defaultDropdownOpen &&
      openMainId &&
      dropdownOpen &&
      item.id !== openMainId
    ) {
      setDropdownOpen(false);
    }
    if (isEditing) fireAnalytics("continue_draft", { category: "publishing" });
  }, [item, openMainId, dropdownOpen]);

  useEffect(() => {
    if (opened !== dropdownOpen) {
      setDropdownOpen(opened);
    }
  }, [opened]);


  useEffect(() => {
    if (isPortfolio && !isVisualizer) {
      setInitialValues({
        nameEdit: item.name,
        descriptionEdit: item.description,
        startDateEdit: item.startDate,
        endDateEdit: item.endDate,
      });
    }
  }, [item]);

  function buttonStatusHandler() {
    if (isPostulation) {
      switch (dat.status) {
        case "SEND":
          return "Pendiente de aprobacion";
        case "ALLOWED":
          return "Solicitud aprobada";
        case "NEGATED":
          return "Solicitud rechazada";
        default:
          return "";
      }
    } else if (isPortfolio) {
      return isEditing ? "Guardar portfolio" : "Editar Portfolio";
    } else if (isProject) {
      return isEditing ? "Guardar proyecto" : "Editar proyecto";
    }
  }

  const showInfoHandler = (bool) => {
    if (allowOpen) {
      setOpenMainId(item.id);
      setDropdownOpen(bool);
    }
  };

  const editHandler = () => {
    if (isPostulation) {
      showInfoHandler(!dropdownOpen);
      return;
    } else if (isProject) {
      setPostulationProject(item);
      return;
    }
    if (!isEditing) {
      handleClose();
    } else {
      let sendImage = newImage.name
        ? [{ id: item.images[0].id, image: newImage }]
        : [];
      openMainModal({
        title: "¿Estas seguro que deseas guardar los cambios?",
        body: "Se actualizara el proyecto de tu portfolio y sera visible en tu perfil.",
        isSuccess: false,
        confirmHandler: () =>
          updatePortfolio(formik.values, sendImage, item.id),
      });
      handleClose();
    }
  };
  // !allowOpen == esta cerrado

  
  return (
    <div className={styles.containerRubro}>    
      <HeaderWithButton
        showImage={false}
        handler={editHandler}
        content={buttonStatusHandler()}
        open={dropdownOpen}
        name={name}
        isVisualizer={isVisualizer}
      />
      {isEditing && Object.keys(initialValues).length !== 0 && !isVisualizer ? (
        <motion.div>
          <DetailsEdit values={formik.values} isEditing={isEditing} />
        </motion.div>
      ) : (
        <DetailsInfo
          type={type}
          opened={opened}
          onClick={onClick}
          allowOpen={allowOpen}
          isPostulation={isPostulation}
          isProject={isProject}
          dropdownOpen={dropdownOpen}
          setDropdownOpen={showInfoHandler}
          name={name}
          zone={zone}
          startDate={startDate}
          endDate={endDate}
          description={description}
          item={item}
          id={id}
          displayInfo={displayInfo}
          isPostulating={isPostulating}
          handleCose={handleClose}
          newImage={newImage}
          updatePortfolio={updatePortfolio}
          formik={formik}
          userData={props.userData}
          isAllowed={isAllowed}
          subProjectBudgets={subProjectBudgets}
          count={count}
          mainProject={mainProject}
          {...props}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    onClick: ownProps.onClick,
    userData: state.general.userData,
    openMainId: state.profile.openMainId,
    displayInfo: state.profile.displayInfo,
    allowOpen: ownProps.allowOpen,
    subProjectBudgets: state.profile.subProjectBudgets,
  };
};
export default connect(mapStateToProps, {
  openMainModal,
  setPostulationProject,
  getProjectQuestions,
  setOpenMainId,
  getSubProjectBudgets,
})(Subproject);
